export const SortContentGroup = (array) => {
  return array.sort(
   function(a, b) {
      if (a.index === b.index) {
         return new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime();
      }
      return a.index > b.index ? 1 : -1;
   });
};
